/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolBungalowIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-bungalow"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M7.85 21.32Q7.3 21.32 6.91 20.94Q6.53 20.55 6.53 20L6.53 15.68L6.45 15.78Q6.15 16.23 5.64 16.35Q5.13 16.48 4.65 16.2Q4.17 15.9 4.05 15.36Q3.92 14.82 4.22 14.35L10.9 4.1Q11.1 3.8 11.39 3.64Q11.68 3.48 12 3.48Q12.32 3.48 12.61 3.64Q12.9 3.8 13.1 4.1L19.77 14.35Q20.07 14.82 19.95 15.35Q19.82 15.88 19.35 16.18Q18.88 16.45 18.36 16.34Q17.85 16.23 17.55 15.78L17.48 15.68L17.48 20Q17.48 20.55 17.09 20.94Q16.7 21.32 16.15 21.32L13.32 21.32L13.32 17Q13.32 16.45 12.94 16.06Q12.55 15.68 12 15.68Q11.45 15.68 11.06 16.06Q10.68 16.45 10.68 17L10.68 21.32ZM12 14.32Q12 14.32 12.28 14.32Q12.55 14.32 12.94 13.94Q13.32 13.55 13.32 13Q13.32 12.45 12.94 12.06Q12.55 11.68 12 11.68Q11.45 11.68 11.06 12.06Q10.68 12.45 10.68 13Q10.68 13.55 11.06 13.94Q11.45 14.32 12 14.32Z" fill={color} />
    </svg>
  );
}
